module.exports = __webpack_public_path__ + "media/images/icon/icons8-Approval-4d99f2101272f27bd542404327b62eb5.png";